<template>
  <v-container>
    <v-card flat>
      <div class="logo">
        <v-img class="logo-img" src="@/assets/Admin_plus_kiosk_logo.svg"></v-img>
      </div>
      <v-card-text>
        <v-autocomplete v-model="managedAcademyId" :items="academies" :loading="isLoading" hide-no-data hide-selected
          item-text="text" item-value="value" :label="$t('message.select_academy')"
          prepend-icon="home"></v-autocomplete>
        <v-text-field prepend-icon="tablet" :label="$t('message.academy_tablet_id')" v-model="loginId"></v-text-field>
        <v-text-field prepend-icon="lock" type="password" :label="$t('message.password')"
          v-model="password"></v-text-field>
      </v-card-text>
      <v-card-text class="d-flex justify-center">
        <circles-loader v-if="loading"></circles-loader>
      </v-card-text>
      <v-card-text class="d-flex justify-center">
        <div v-if="message" class="messages" color="primary">{{ message }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed large color="primary" @click="authenticate">
          {{ $t('message.authenticate') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import Api from "@/services/Api";

export default {
  name: 'Login',
  data() {
    return {
      loginId: null,
      password: null,
      message: null,
      loading: false,
      isLoading: true,
      academies: [],
      managedAcademyId: null
    }
  },
  components: {
    CirclesLoader
  },
  created() {
    this.setLang();
    Api()
      .get('admintablet/academies')
      .then(response => {
        this.academies = response.data;
        this.isLoading = false;
      })
  },
  methods: {
    authenticate() {
      var data = {
        id: this.loginId,
        password: this.password,
        managedAcademyId: this.managedAcademyId
      };
      this.loading = true;
      Api()
        .post('admintablet/authenticate', data)
        .then(response => {
          this.processLoggedIn(response);
        })
        .catch(e => {
          console.log(e);
          if (e && e.response.data) {
            this.loading = false;
            this.message = this.$t('message.' + e.response.data.localizedMessage);
          }
        });
    },
    processLoggedIn(response) {
      if (response.data.token) {
        var lang = response.data.managedAcademy.academy.preferredLang;
        if (!lang)
          lang = 'en';
        console.log(response.data);
        this.$store.dispatch("setTabletToken", response.data.token);
        this.$store.dispatch("setTabletId", response.data.tabletId);
        this.$store.dispatch("setTabletName", response.data.managedAcademy.academy.name);
        this.$store.dispatch("setTabletSelectedAcademy", response.data.managedAcademy.academy._id);
        this.$store.dispatch("setTabletManagedAcademy", response.data.managedAcademy._id);
        this.$store.dispatch("setTabletLanguage", lang);
        this.$i18n.locale = lang;
        localStorage.tablet_token = response.data.token;
        window.location = 'checkin';
      }
    }
  }
}
</script>
<style>
.logo {
  width: 100px;
  margin: 0 auto;
  display: block;
  margin-top: 10px;
}

.icon-overlay {
  position: absolute;
  height: auto;
  text-align: center;
  width: 200px;
  top: 20px;
  margin-left: 25px
}
</style>